export function callbackIfIdle(callback: Function, idleTime: number) {
  const timeout = setTimeout(() => {
    callback();
    removeEventListeners();
  }, idleTime);

  const handleInterruption = () => {
    clearTimeout(timeout);
    removeEventListeners();
  };

  document.addEventListener('scroll', handleInterruption);
  document.addEventListener('mousemove', handleInterruption, { capture: true });
  document.addEventListener('touchstart', handleInterruption, { capture: true });
  document.addEventListener('click', handleInterruption, { capture: true });

  function removeEventListeners() {
    document.removeEventListener('scroll', handleInterruption);
    document.removeEventListener('mousemove', handleInterruption);
    document.removeEventListener('touchstart', handleInterruption);
    document.removeEventListener('click', handleInterruption);
  }

  return handleInterruption;
}
